const getMaterialFile = (material = {}) => {
  const file = material?.arquivo_pdfdocx ?? material ?? {};

  if (typeof file === "string") {
    return {
      url: file,
      name: file,
    };
  }

  if (typeof file !== "object" || file === null) {
    return {};
  }

  return file;
};

const getFileNameFromUrl = (url = "") => {
  if (!url) {
    return "";
  }

  return url.split("/").pop()?.split("?")[0] ?? "";
};

export const normalizeSupportMaterials = (materials = undefined) => {
  const normalizedMaterials = Array.isArray(materials)
    ? materials
    : Object.values(materials ?? {
    });

  return normalizedMaterials
    .map((material) => {
      const file = getMaterialFile(material);
      const url = file.url || file.link || material?.url || material?.link || "";
      const name = file.title
        || file.filename
        || file.name
        || material?.name
        || getFileNameFromUrl(url);

      if (!url) {
        return null;
      }

      return {
        ...material,
        name,
        url,
      };
    })
    .filter(Boolean);
};
